<template lang="pug">
  #activation-view.body: .body-inner
    form(@submit.prevent="validateSelf" novalidate)
      UiFormField(
        v-model="phoneModel"
        v-validate="form.phone.rules"
        v-bind="form.phone.params"
        :error="errors.first(form.phone.params.name)"
        :fieldBtn="phoneFieldBtnShow"
        @field-btn-click="sendSMSHandler"
      )
      UiFormField.spec-margin(
        v-model="codeModel"
        v-validate="form.sms_code.rules"
        v-bind="form.sms_code.params"
        :error="errors.first(form.sms_code.params.name)"
        :fieldBtn="codeFieldBtnShow"
        @field-btn-click="codeVerifyHandler"
      )
      //- Conditions -----------------------------------------------------------
      p.conditions
        | Продолжая, вы подтверждаете своё согласие с условиями
        a(@click.prevent="showTermsByRouteName('user-agreements')" href="#")  пользовательского соглашения
        | .
      //- Agreement ------------------------------------------------------------
      p.agreement
        input(type="checkbox" id="agreement" v-model="agreement")
        label(for="agreement"): UiIcon(icon="ui-icon-check")
        | Я согласен с
        a(@click.prevent="showTermsByRouteName('terms-of-use')" href="#")  {{ termsRulesText }}
        |  и даю согласие на
        a(@click.prevent="showTermsByRouteName('privacy-policy')" href="#")  обработку персональных данных
        | .
      //- Finam info -----------------------------------------------------------
      p.finam-info.no-select Получить портфель и перейти к открытию брокерского счета
</template>

<script>
import { _cfg } from '@/config'
import store from '@/store'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Activation',
  // Before route enter ------------------------------------------------- [Hook]
  async beforeRouteEnter (to, from, next) {
    if (from.name !== 'risk') return next()
    const { status, errors } = await store.dispatch('moduleUser/fetchTickersData')
    if (status) {
      next()
    } else {
      store.commit('moduleWizard/SET_NAV_FIELD', { f: 'errorTextNext', v: errors.global[0] })
    }
  },
  // Created ------------------------------------------------------------ [Hook]
  created () {
    this.SET_CURRENT_VIEW({ vm: this })
    this.disableNext = !this.agreement
  },
  // Data ----------------------------------------------------------------------
  data () {
    return {
      form: {
        phone: {
          rules: {
            required: true,
            min: 7,
            max: 20
          },
          params: {
            name: 'phone',
            type: 'tel',
            label: 'Телефон',
            isDisabled: false,
            mask: '+####################',
            fieldBtnText: 'Выслать СМС',
            fieldBtnIsDisabled: false,
            fieldBtnError: false
          }
        },
        sms_code: {
          rules: {
            required: true,
            length: 6
          },
          params: {
            name: 'sms_code',
            type: 'text',
            label: 'Код из СМС',
            isDisabled: true,
            mask: '###-###',
            fieldBtnText: 'Подтвердить',
            fieldBtnIsDisabled: false
          }
        }
      },
      sms: {
        delay: _cfg.common.smsDelay
      }
    }
  },
  // Watch ---------------------------------------------------------------------
  watch: {
    'agreement' (v) {
      this.disableNext = !(v && this.codeConfirmed)
    },
    codeConfirmed: {
      handler (v) {
        if (v) {
          this.form.sms_code.params.fieldBtnText = 'Подтвержден'
          this.form.phone.params.fieldBtnText = 'Подтвержден'
          this.form.phone.params.fieldBtnIsDisabled = true
          this.form.sms_code.params.fieldBtnIsDisabled = true
          this.form.phone.params.isDisabled = true
          this.form.sms_code.params.isDisabled = true
        }
        this.disableNext = !(v && this.agreement)
      },
      immediate: true
    }

  },
  // Computed ------------------------------------------------------------------
  computed: {
    // Vuex map getters of the Wizard SM
    ...mapGetters('moduleWizard', [
      'getNavFields'
    ]),
    // Vuex map getters of the User SM
    ...mapGetters('moduleUser', [
      'getUserData',
      'getSMSData'
    ]),
    // Phone model
    phoneModel: {
      get () { return this.getUserData.phone },
      set (v) { this.SET_USER_DATA_FIELD({ f: 'phone', v }) }
    },
    // Code model
    codeModel: {
      get () { return this.getSMSData.sms_code },
      set (v) { this.SET_SMS_FIELD({ f: 'sms_code', v }) }
    },
    // Disable next
    disableNext: {
      get () { return this.getNavFields.disableNext },
      set (v) { this.SET_NAV_FIELD({ f: 'disableNext', v }) }
    },
    // Code confirmed
    codeConfirmed: {
      get () { return this.getSMSData.codeConfirmed },
      set (v) { this.SET_SMS_FIELD({ f: 'codeConfirmed', v }) }
    },
    // Agreement
    agreement: {
      get () { return this.getUserData.agreement },
      set (v) { this.SET_USER_DATA_FIELD({ f: 'agreement', v }) }
    },
    // SMS was sent
    smsWasSent: {
      get () { return this.getSMSData.smsWasSent },
      set (v) { this.SET_SMS_FIELD({ f: 'smsWasSent', v }) }
    },
    // Show phone field btn
    phoneFieldBtnShow () {
      return this.phoneModel.length > 6 && !this.errors.has(this.form.phone.params.name)
    },
    // Show code field btn
    codeFieldBtnShow () {
      return this.codeModel.length > 5 && !this.errors.has(this.form.sms_code.params.name)
    },
    // Robot message
    robotMessage () {
      const branded = this.$store.state.config.branded
      if (branded === 'anderida' || branded === 'ds' || branded === 'scapital') return 'Я сделал запрос на получение биржевых котировок и собрал для вас персональный инвестиционный портфель. Для безопасного доступа в систему требуется СМС-идентификация.'
      return 'Определена финальная комбинация портфеля. Для просмотра введите код безопасности из SMS сообщения.'
    },
    // Terms rules text
    termsRulesText () {
      const branded = this.$store.state.config.branded
      if (branded === 'anderida') return 'правилами пользования клиентским порталом Anderida Financial Group'
      if (branded === 'ds') return 'правилами пользования клиентским порталом ДС Консалтинг'
      if (branded === 'scapital') return 'правилами пользования клиентским порталом Smirnova Capital'
      return 'правилами пользования сервисом Right'
    }
  },
  // Methods -------------------------------------------------------------------
  methods: {
    // Vuex map mutations of the Wizard SM
    ...mapMutations('moduleWizard', [
      'SET_NAV_FIELD',
      'SET_CURRENT_VIEW'
    ]),
    // Vuex map mutations of the User SM
    ...mapMutations('moduleUser', [
      'SET_USER_DATA_FIELD',
      'SET_SMS_FIELD'
    ]),
    // Vuex map actions of the User SM
    ...mapActions('moduleUser', [
      'sendSMS',
      'confirmSMS',
      'userRegistration'
    ]),
    // Vuex map actions of the Security SM
    ...mapActions('moduleSecurity', [
      'sendMessage'
    ]),
    // Send SMS handler
    async sendSMSHandler () {
      const { status, errors } = await this.sendSMS()
      if (status) {
        this.form.phone.params.fieldBtnText = 'СМС отправлена'
        this.form.phone.params.fieldBtnIsDisabled = true
        this.form.sms_code.params.isDisabled = false
        this.errors.add({ field: this.form.sms_code.params.name, msg: 'Введите код из СМС' })
        this.SET_NAV_FIELD({ f: 'disablePrev', v: true })
        this.sendSMSPause()
      } else {
        if ('fields' in errors) {
          for (const field in errors.fields) {
            this.errors.add({ field, msg: errors.fields[field][0] })
          }
        } else {
          this.errors.add({ field: this.form.phone.params.name, msg: errors.global[0] })
        }
      }
    },
    // Send SMS pause
    sendSMSPause () {
      const that = this // Save Vue context
      function timer () {
        that.sms.delay--
        that.form.phone.params.fieldBtnText = _cfg.text.accountActivation.smsDelay(that.sms.delay)
        if (that.sms.delay === 0) {
          that.sms.delay = _cfg.common.smsDelay
          that.form.phone.params.fieldBtnIsDisabled = false
          that.form.phone.params.fieldBtnText = 'Выслать СМС'
          setTimeout(function () {
          }, 1000)
        } else {
          setTimeout(timer, 1000)
        }
      }
      setTimeout(function () {
        timer()
      }, 1000)
    },
    // Confirm SMS handler
    codeVerifyHandler () {
      this.$validator.validate('sms_code').then(async result => {
        if (!result) return
        const { status, errors } = await this.confirmSMS()
        if (status) {
          this.disableNext = !this.agreement
        } else {
          if ('fields' in errors) {
            for (const field in errors.fields) {
              this.errors.add({ field, msg: errors.fields[field][0] })
            }
          } else {
            this.errors.add({ field: this.form.sms_code.params.name, msg: errors.global[0] })
          }
        }
      })
    },
    // Reg user
    async regUser () {
      const { status } = await this.userRegistration()
      if (status) {
        this.sendMessage({ e: 'ActivationComplete' })
        return true
      } // all is fine
      this.form.sms_code.params.fieldBtnText = 'Подтвердить'
      this.form.phone.params.fieldBtnText = 'Выслать СМС'
      this.form.phone.params.fieldBtnIsDisabled = false
      this.form.sms_code.params.fieldBtnIsDisabled = false
      this.form.phone.params.isDisabled = false
      this.form.sms_code.params.isDisabled = false
      this.SET_SMS_FIELD({ f: 'sms_code', v: '' })
      this.SET_SMS_FIELD({ f: 'codeConfirmed', v: false })
      return false
    },
    // Show terms by route name
    showTermsByRouteName (routeName) {
      this.$router.push({ name: routeName }).catch(e => {})
    },
    // Self back validator
    async backSelf () {
      this.disableNext = false
      return true
    },
    // Self next validator
    async nextSelf () {
      // eslint-disable-next-line no-return-await
      return await this.regUser()
    }
  }
}
</script>
